import React from 'react';

/**
 * SectionHeader renders a consistent title block for each wizard step.
 *
 * @param {number|string} [number] - Section number badge.
 * @param {string} title           - Section title.
 * @param {React.ReactNode} [tip]  - Optional advisory tip displayed below the title.
 */
export default function SectionHeader({ number, title, tip }) {
  return (
    <div className="mb-4">
      <div className="d-flex align-items-baseline gap-2">
        {number != null && number !== '' && (
          <span
            className="badge rounded-pill cashflow-badge-dark"
            style={{ fontSize: '0.85rem', padding: '0.35em 0.8em' }}
          >
            {number}
          </span>
        )}
        <h2 className="h4 fw-bold mb-0">{title}</h2>
      </div>
      {tip && (
        <div className="alert alert-light border-start border-4 border-danger mt-3 mb-0 py-2 small">
          <i className="bi bi-lightbulb me-2 text-danger" />
          {tip}
        </div>
      )}
    </div>
  );
}
